export default class QaiChallengeViewModel {
    templateId: number
    sectionId: number
    questionId: number
    note: string
    agentCount: number;
}